import React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import BackgroundImage from 'gatsby-background-image'
import _ from 'lodash'
import { IconContext } from "react-icons";
import { MdClose } from 'react-icons/md';

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import Header from "./../../../components/header"
import BackButton from "./../../../components/BackButton"

export default class Prenom extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      letters: [],
      prenom: null,
      message: '',
      monPrenom: null,
      playMode: false,
    }
  }

  setMessage = (message, isWarning) => {
      this.setState({
        message,
      });
  }

  addLetterClick = (letter) => {
    if (!this.state.playMode) {
      return;
    }
    var currentIndex = this.state.letters.length;
    if (letter === this.state.prenom[currentIndex]) {
      this.setState({
        letters: [...this.state.letters, letter],
        message: null,
      });
      setTimeout(() => {
        if (this.state.letters.length === this.state.prenom.length) {
          this.setMessage('Félicitations !!!')
        }
      }, 1);
    }
    else {
      this.setMessage('Oups, ce n‘est pas la bonne lettre ! cherche la lettre ' + this.state.prenom[currentIndex].toUpperCase(), true)
    }
  }

  updatePrenom = (e) => {
    e.preventDefault();
    var value = document.getElementById('prenom-input').value;
    if (value.length > 16) {
      document.getElementById('prenom-input').value = '';
      alert('Ton prénom dépasse la longueur maximale pour ce jeu ! Utilise un surnom ou un diminutif pour continuer');;
      return;
    }
    if (!value) {
      alert('N‘oublie pas d‘indiquer ton prénom dans le champ ci-dessus !')
      return;
    }
    var normalized = value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g,'').split('');
    var alphabet = [...Array(26)].map((_, y) => String.fromCharCode(y + 97));
    normalized = normalized.filter((letter) => alphabet.indexOf(letter) !== -1);
    this.setState({
      prenom: normalized,
      monPrenom: value,
    });
  }

  render() {
    const data = this.props.data;
    const alphabet = _.keyBy(data.alphabet.edges, ({node}) => node.name);
    // const alphabet = [...Array(26)].map((_, y) => String.fromCharCode(y + 97));
    if (this.state.prenom === null) {
      // return ();
      return (
        <Layout>
        <Header title="Retour" href="/estacades/jeux" />
        <SEO title="Jeu - Écris ton prénom !" />

        <div className="banner no-bg">
        </div>
        <p>
          Bonjour !
        </p>
        <p>
          Avant de commencer peux-tu me dire ton prénom ?
        </p>
        <form onSubmit={this.updatePrenom}>
          <input type="text" id="prenom-input" required className="btn" />
          <input type="submit" className="btn" onClick={this.updatePrenom} value="Valider !"/>
        </form>
      </Layout>
      )
    }
    return (
      <Layout>
        <Header title="Retour" href="/estacades/jeux" />
        <SEO title="Jeu - Écris ton prénom !" />

        <div className="banner no-bg">
        </div>

        <p>
          Bonjour {this.state.monPrenom} !
        </p>
        <p>
          Savais-tu que pour communiquer en mer, les équipages utilisaient un code international où chaque lettre correspond à un pavillon ? L‘ensemble de ces pavillons forme le « code international des signaux maritimes ».
        </p>
        <p>
          En hissant plusieurs pavillons les uns à côté des autres on peut former des mots et même des phrases !
        </p>
        <p>
          Voici la liste des pavillons et les lettres correspondantes de l‘alphabet :
        </p>
        <div className="alphabet-wrapper">
          {data.alphabet.edges.map(({ node }) => (
            <div className="alphabet-item" key={node.name} onClick={() => this.addLetterClick(node.name)} role="button">
              <img src={node.publicURL} alt={node.name} />
              <div>{node.name}</div>
            </div>
          ))}
        </div>

        <p>
          <b>Et si on essayait d‘écrire ton prénom ?</b> Clique sur le bouton ci-dessous pour jouer !
        </p>
        {!this.state.playMode &&
          <>
            <button className="btn" onClick={() => this.setState({playMode: true})}>Je veux jouer !</button>
            <BackButton />
          </>
        }

        {this.state.playMode &&
          <>
            <p>
              Super ! Appuie sur chaque lettre dans l‘alphabet ci-dessus pour écrire ton prénom en signaux maritimes.
            </p>
            <p>
              <b>Attention</b>, dans ce code les accents n‘existent pas ! remplace les lettres avec accents par des lettres normales.
            </p>
            <div className="mon-prenom-placeholder">
            </div>

            <div className="mon-prenom">
              {this.state.message &&
                <div className="prenom-message">
                  {this.state.message}
                </div>
              }
              <div className="prenom-letters">
                {this.state.prenom.map((letter, i) => (
                  <div className="prenom-item" key={i}>
                    {this.state.letters[i] && <img src={alphabet[this.state.letters[i]].node.publicURL} alt="" />}
                    {!this.state.letters[i] && <div className="empty-letter">{letter}</div>}
                  </div>
                ))}
              </div>
            </div>
          </>
        }
      </Layout>
    )
  }
}
/*
          {this.state.prenom.length !== 0 &&
            <div className="prenom-reset" onClick={() => this.setState({prenom: []})} role="button">
              <IconContext.Provider value={{ color:"white", size:"60" }}>
                <MdClose />
              </IconContext.Provider>
            </div>
          }
          */
            // <img src="{{ publicURL }}" />
        // {this.state.open ? <div dangerouslySetInnerHTML={{ __html: data.learnMore.html }} /> : <p className="learn-more" onClick={this.toggleOpen}>En savoir plus</p>}

export const query = graphql`
  query {
    bg: file(relativePath: { eq: "estacades/anna-rosa/anna-rosa.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
        fixed(height: 120) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    alphabet: allFile(
      filter: {relativeDirectory: {regex: "/estacades/jeux/signals/"}},
      sort: {fields: name}
    ) {
      edges {
        node {
          id
          publicURL
          name
        }
      }
    }
  }
`
